import { Component, input, signal, effect } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';
import { Rubric } from '@mira-avant/mtlibs';
import { RubricService } from '../../../../services/rubric.service';
import {
	DropdownControlComponent,
	DropdownOption,
} from '../../../controls/standard/dropdown-control/dropdown-control.component';
import { BaseFieldComponent } from '../base-field/base-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';

@Component({
	selector: 'app-rubric-level-dropdown-field',
	standalone: true,
	imports: [AppModule, ZorroModule, ThirdPartyModule, AngularModule, DropdownControlComponent],
	templateUrl: './rubric-level-dropdown-field.component.html',
	styleUrl: './rubric-level-dropdown-field.component.scss',
})
export class RubricLevelDropdownFieldComponent extends BaseFieldComponent {
	// Inputs as signals
	readonly rubric = input<Rubric | undefined>();
	readonly multiple = input<boolean>(false);

	// Reactive options
	readonly options = signal<DropdownOption[]>([]);

	public static override validators: ValidatorFn[] = [Validators.required];

	constructor(private rubricService: RubricService) {
		super();

		// React to changes of rubric input
		effect(() => {
			const currentRubric = this.rubric();

			if (currentRubric?.code) {
				this.rubricService
					.getRubricLevels$(currentRubric.code)
					.then(levels => {
						this.options.set(
							levels.map(level => ({
								value: level.uuid,
								label: level.name,
							}))
						);
					})
					.catch(error => {
						console.error('Error fetching rubric levels:', error);
						this.options.set([]);
					});
			} else {
				// No rubric → clear options
				this.options.set([]);
			}
		});
	}
}
